import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 1,
  class: "text-left w-full"
}
const _hoisted_3 = { class: "w-full ml-2 border-separate border-spacing-y-1.5" }
const _hoisted_4 = { class: "group" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "align-top" }
const _hoisted_7 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { QueryResult, RecordInfo, SOA } from '@/model/Api';

type SoaRecordWithInfo = {
  record: SOA;
} & RecordInfo

// Input:         'aa\.bb\.cc.domain.co.uk
// Match group 1: 'aa\.bb\.cc'
// Match group 3:            'domain.co.uk'

export default /*@__PURE__*/_defineComponent({
  __name: 'SoaRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const adminHostRegex = /^((.*\\\.)?[^.]*)\.(.*)/;

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => props.records.response.answer.filter((item): item is SoaRecordWithInfo => item.record.recordType === 'SOA'));

const adminUserAndHost = computed(() => {
  if (processedRecords.value.length > 0) {
    const match = processedRecords.value[0].record.admin.match(adminHostRegex);
    if (match) {
      return {
        user: match[1].replaceAll('\\.', '.'),
        host: match[3].slice(0, -1), // Remove the trailing dot
      };
    }
  }
  return {
    user: '',
    host: '',
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showRawOutput.value)
      ? (_openBlock(), _createBlock(RawRecords, {
          key: 0,
          records: __props.records
        }, null, 8, ["records"]))
      : (processedRecords.value.length !== 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
            _cache[7] || (_cache[7] = _createElementVNode("colgroup", null, [
              _createElementVNode("col", { class: "w-3/4" }),
              _createElementVNode("col", { class: "w-1/4" })
            ], -1)),
            _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "border-b-2 border-gray-200 text-left" }, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "py-1.5 font-medium"
                }, "SOA data"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "py-1.5 font-medium"
                }, "Revalidate in")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedRecords.value, (record, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("table", _hoisted_3, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_4, [
                          _cache[0] || (_cache[0] = _createElementVNode("th", {
                            scope: "row",
                            class: "font-medium"
                          }, "Start of authority", -1)),
                          _createElementVNode("td", null, [
                            _createVNode(DnsRecordsLink, {
                              domain: record.record.host,
                              class: "text-blue-600 hover:text-blue-800 hover:underline"
                            }, null, 8, ["domain"]),
                            _createVNode(Copy, {
                              content: record.record.host,
                              class: "[visibility:hidden] group-hover:visible"
                            }, null, 8, ["content"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[1] || (_cache[1] = _createElementVNode("th", {
                            scope: "row",
                            class: "font-medium"
                          }, "Email", -1)),
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(adminUserAndHost.value.user) + "@", 1),
                            (__props.domain !== adminUserAndHost.value.host)
                              ? (_openBlock(), _createBlock(DnsRecordsLink, {
                                  key: 0,
                                  domain: adminUserAndHost.value.host,
                                  class: "text-blue-600 hover:text-blue-800 hover:underline"
                                }, null, 8, ["domain"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(adminUserAndHost.value.host), 1))
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[2] || (_cache[2] = _createElementVNode("th", {
                            scope: "row",
                            class: "font-medium"
                          }, "Serial", -1)),
                          _createElementVNode("td", null, _toDisplayString(record.record.serial), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("th", {
                            scope: "row",
                            class: "font-medium"
                          }, "Refresh", -1)),
                          _createElementVNode("td", null, [
                            _createVNode(Duration, {
                              seconds: record.record.refresh
                            }, null, 8, ["seconds"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[4] || (_cache[4] = _createElementVNode("th", {
                            scope: "row",
                            class: "font-medium"
                          }, "Retry", -1)),
                          _createElementVNode("td", null, [
                            _createVNode(Duration, {
                              seconds: record.record.retry
                            }, null, 8, ["seconds"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[5] || (_cache[5] = _createElementVNode("th", {
                            scope: "row",
                            class: "font-medium"
                          }, "Expire", -1)),
                          _createElementVNode("td", null, [
                            _createVNode(Duration, {
                              seconds: record.record.expire
                            }, null, 8, ["seconds"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("th", {
                            scope: "row",
                            class: "font-medium"
                          }, "Negative cache TTL", -1)),
                          _createElementVNode("td", null, [
                            _createVNode(Duration, {
                              seconds: record.record.minimum
                            }, null, 8, ["seconds"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_6, [
                    _createVNode(Duration, {
                      seconds: record.record.ttl
                    }, null, 8, ["seconds"])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, "No SOA records found."))
  ]))
}
}

})